var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.849609 2.31507C0.849609 1.73786 1.05232 1.26167 1.45772 0.886501C1.86312 0.511315 2.39016 0.32373 3.0388 0.32373C3.67587 0.32373 4.1913 0.508423 4.58513 0.877843C4.99053 1.2588 5.19324 1.75518 5.19324 2.36702C5.19324 2.92113 4.99633 3.38288 4.6025 3.7523C4.19711 4.13325 3.66428 4.32373 3.00405 4.32373H2.98668C2.3496 4.32373 1.83417 4.13325 1.44034 3.7523C1.04651 3.37135 0.849609 2.89227 0.849609 2.31507ZM1.07548 17.4666V5.89949H4.93262V17.4666H1.07548ZM7.06969 17.4666H10.9268V11.0077C10.9268 10.6037 10.9732 10.292 11.0658 10.0726C11.228 9.68014 11.4741 9.34825 11.8042 9.07697C12.1344 8.80568 12.5484 8.67005 13.0465 8.67005C14.3438 8.67005 14.9925 9.54161 14.9925 11.2848V17.4666H18.8496V10.8345C18.8496 9.12603 18.4442 7.83022 17.6334 6.9471C16.8226 6.06399 15.7512 5.62243 14.4191 5.62243C12.9249 5.62243 11.7608 6.26312 10.9268 7.54451V7.57914H10.9095L10.9268 7.54451V5.89949H7.06969C7.09285 6.26889 7.10444 7.41751 7.10444 9.34537C7.10444 11.2732 7.09285 13.9803 7.06969 17.4666Z",
    fill: "#024E82"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.fdf6c72542e0d0cd07493abf5b3eb2a9.svg";
export { ForwardRef as ReactComponent };